export default {
  nav_home: 'Accueil',
  nav_guide: 'Guide USFans Spreadsheet',
  nav_shopping_guide: 'Guide d’achat',
  nav_categories: 'Catégories',
  nav_browse: 'Parcourir les catégories',
  lang_label: 'Langue',
  footer_tagline: 'Un hub indépendant et organisé de ressources, de guides et de conseils de sécurité USFans Spreadsheet.',
  footer_categories: 'Catégories',
  footer_resources: 'Ressources',
  footer_guide: 'Guide USFans Spreadsheet',
  footer_home: 'Accueil',
  footer_disclaimer: 'Ceci est un site d’information indépendant et n’est pas le site officiel d’USFans.',
  footer_rights: 'Tous droits réservés.',
  footer_visit_main: 'Visiter le site principal',
};